/*
 * Copyright (c) 2017, Indigen Solutions. All rights reserved.
 *
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 *
 * This software is the confidential and proprietary information.
 *
 * You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement
 * you entered into.
 */

import { Beneficiary } from "./Beneficiary";

export const productGPISamplingIntervalsItems = [
    { name: "month", label: "Mensuel" },
    { name: "trimester", label: "Trimestriel" },
    { name: "semester", label: "Semestriel" },
    { name: "year", label: "Annuel" }
];

export const productGPISamplingDatesItems = [
    { name: "08", label: "08" },
    { name: "15", label: "15" },
];

export const productGPIHealthStateItems = [
    { name: "yes", label: "Je déclare avoir moins de 51 ans et souscrire un montant de capital décès strictement inférieur à 100 000 €, " +
    "dans ce cas je renseigne le Profil de santé ci-dessous." },
    { name: "no", label: "Je ne satisfais pas aux critères indiqués ci-dessus. Dans ce cas, mon conseiller me remet le dossier médical " +
    "confidentiel à compléter par mes soins ou avec l'aide de mon médecin traitant, et à retourner séparément de la demande d'adhésion, " +
    "dans l'enveloppe confidentielle 'Secret Médical' qui m'est fournie." },
];

export const productGPIClauseItems = [
    { name: "standard", label: "Clause standard : le conjoint de l'assuré non séparé judiciairement, à défaut les enfants de l'assuré " +
        "nés ou à naître, vivants ou représentés, à défaut les héritiers de l'assuré." },
    { name: "beneficiary", label: "Clause libre : autre(s) bénéficiaire(s). " +
        "Merci de renseigner précisément les informations ci-dessous." },
];

export const productGPISignDeclarationItems = [
    { name: "yes", label: "Oui, je peux signer et attester exact ce Profil de santé." },
    { name: "no", label: "Non, je ne peux pas signer ce Profil de santé, j'adresse séparement au médecin conseil sous pli cacheté le dossier " +
    "médical confidentiel dûment complété." },
];

export interface ProductGPI {

    isIAD?: boolean;
    IADGuarantee?: number;
    IADContribution?: number;
    
    isAccident?: boolean;
    accidentGuarantee?: number;
    accidentContribution?: number;

    isITT?: boolean;
    ITTFranchise?: number;
    ITTGuarantee?: number;
    ITTContribution?: number;

    isIPT?: boolean;
    IPTGuarantee?: number;
    IPTContribution?: number;

    samplingInterval?: "month" | "trimester" | "semester" | "year";
    samplingDate?: "08" | "15";
    contribution?: number;

    healthState?: "yes" | "no";
    healthOptin?: boolean;

    signDeclaration?: "yes" | "no";

    beneficiaryClause?: "standard" | "beneficiary";
    beneficiaries: Beneficiary[];
}



// WEBPACK FOOTER //
// ./src/types/ProductGPI.ts